<div *ngIf="dataShareService.tenantConfig$ | async; else loading">
  <app-default-card
    [info]="''"
    [showChildComponent]="true"
    [showThisComponent]="true"
    [title]="withoutExplicitContract ? 'Ihre Daten' : 'Ihr Vertragsangebot'"
    spyTarget="Info">
    <div>
      <p>
        Sehr geehrte(r)
        {{ feederContract?.customer?.salutation | salutationTitle | async }}
        {{ feederContract?.customer?.lastName }},
      </p>

      <!--  -->
      <ng-container *ngIf="withoutExplicitContract; else withContractTitle">
        <p>
          um Ihnen Ihre Einspeisevergütung auszahlen zu können, benötigen wir noch ein paar Informationen von
          Ihnen. Bitte prüfen Sie die Daten und nehmen Ergänzungen in den Pflichtfeldern vor.
        </p>
      </ng-container>

      <ng-template #withContractTitle>
        <p>
          um Ihnen Ihre Einspeisevergütung auszahlen zu können, benötigen wir noch ein paar Informationen von
          Ihnen. Bitte prüfen Sie die Daten und nehmen Ergänzungen in den Pflichtfeldern vor. Im Anschluss
          können Sie den {{ contractType }}-Einspeisevertrag abschließen.
        </p>

        <p>
          Falls Sie keinen EEG-Einspeisevertrag abschließen möchten, können Sie den Button „Ohne Vertrag
          fortfahren“ verwenden. Der Abschluss des EEG-Einspeisevertrages stellt keine Pflicht dar und führt
          zu keinerlei Nachteilen für Sie, da alle Punkte des Vertrages im EEG (Erneuerbaren-Energien-Gesetz)
          gesetzlich festgehalten sind.
        </p>
      </ng-template>

      <p>Im Voraus vielen Dank für Ihre Unterstützung.</p>
      <p>Bei Fragen sind wir gerne für Sie da.</p>
    </div>
  </app-default-card>

  <app-default-card
    [info]="''"
    [showChildComponent]="feederContract"
    [showThisComponent]="true"
    [title]="'Daten zu Ihrer Netzanmeldung (' + contractType + ')'"
    spyTarget="gridRegistrationData">
    <!-- MACHT HIER KEINEN SINN - NB iust klar, MSB kommt unten nochmal. -->
    <!--<section>
      <app-company-location-summary
        [companyLocation]="feederContract?.companyLocation"></app-company-location-summary>
    </section>-->

    <section>
      <app-connection-object-summary
        [connectionObjectAdditionalInfo]="feederContract?.connectionObjectAdditionalInfo"
        [connectionObject]="feederContract?.connectionObject"></app-connection-object-summary>
    </section>

    <section>
      <app-filiation-data-summary
        [contactData]="feederContract?.customer"
        [title]="'Vertragspartner'"></app-filiation-data-summary>
    </section>

    <section>
      <app-filiation-data-summary
        [contactData]="feederContract?.invoiceContact"
        [title]="'Abweichende Rechnungsanschrift'"></app-filiation-data-summary>
    </section>

    <section>
      <app-feeder-contract-summary
        [feederContract]="feederContract"
        [title]="'Technischen Daten der Netzanmeldung'"></app-feeder-contract-summary>
    </section>
  </app-default-card>

  <app-fc-contract-confirmation-form
    #form
    (onErrorsChanged)="onFormErrorsChanged($event)"></app-fc-contract-confirmation-form>

  <app-default-card
    [info]="''"
    [showChildComponent]="true"
    [showThisComponent]="true"
    [title]="'Abschluss'"
    spyTarget="Info">
    <!--  <form-row>
      <div
        class="button-container"
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="20px">
        <app-custom-button
          (onClick)="generateDocument()"
          [title]="'Vertragsvorschau-PDF erzeugen'"></app-custom-button>
      </div>
    </form-row> -->
    <form-row *ngIf="errorFormList && errorFormList.length > 0">
      <mat-error>
        <div class="col">
          <strong>Bitte beheben Sie die Fehler im Formular um mit dieser Aktion fortzufahren</strong>
        </div>
      </mat-error>
    </form-row>
    <form-row>
      <div *ngIf="!withoutExplicitContract">
        <app-form-confirmation
          (onActionClickedEvent)="actionToRun($event)"
          [actionConfirm]="'acceptOffer'"
          [actionReject]="null"
          [actions]="actions"
          [errorFormList]="errorFormList"
          [hideError]="true"
          [message]="'Sind Sie sicher, dass Sie den Vertrag abschließen möchten?'"
          [textConfirm]="'Vertrag abschließen'"></app-form-confirmation>
      </div>
      <div>
        <app-form-confirmation
          (onActionClickedEvent)="actionToRun($event)"
          [actionConfirm]="'acceptOfferWithoutContract'"
          [actionReject]="null"
          [actions]="actions"
          [errorFormList]="errorFormList"
          [hideError]="true"
          [message]="
            withoutExplicitContract
              ? 'Mit dem Bestätigen übermitteln Sie uns Ihre Daten. Wir werden diese Prüfen uns ihnen im nächsten Schritt Bestätigung zusenden.'
              : 'Der Nicht-Abschluss des Vertrages führt für Sie zu keinerlei Nachteilen. Alle Punkte des Vertrages sind im EEG (Erneuerbaren-Energien-Gesetz) gesetzlich festgehalten.\n\n Möchten Sie ohne Vertrag fortfahren?'
          "
          [textConfirm]="
            withoutExplicitContract ? 'Daten übermitteln' : 'Ohne Vertrag fortfahren'
          "></app-form-confirmation>
      </div>
    </form-row>
  </app-default-card>
  <div style="height: 5em"></div>
</div>
<ng-template #loading>
  <app-loading-overlay></app-loading-overlay>
</ng-template>
